import lazySizes from 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

lazySizes.cfg.lazyClass = 'lazy';
lazySizes.cfg.expand = 250;
lazySizes.cfg.expFactor = 1.5;
